<div class="dateRangePickerWrapper">
  <div class="tw-p-4">
    <div class="tw-relative calendarActions">
      <button  class="calendar-action calendar-action--prev" type="button" (click)="!showYearPicker ? goToPreviousMonth(): previousYears()">
        <i-icon [name]="'chevron-left'" [height]="'tw-h-5'" [width]="'tw-w-5'" class="!tw-block"></i-icon>
      </button>
      <button  class="calendar-action calendar-action--next" type="button" (click)="!showYearPicker ? goToNextMonth(): nextYears()">
        <i-icon [name]="'chevron-right'" [height]="'tw-h-5'" [width]="'tw-w-5'" class="!tw-block"></i-icon>
      </button>
    </div>
    <div class="tw-flex tw-gap-5">
      <div class="calendar">
        @if (!showYearPicker) {
        <h4 class="tw-text-center tw-text-[#010f12] tw-text-lg tw-font-medium tw-font-['Satoshi'] tw-capitalize tw-leading-normal tw-mb-3">
          <span>{{ currentMonth | date: 'MMMM' }}</span>
          <button type="button" class="tw-px-1 tw-py-0.5 tw-rounded-md tw-ml-1 tw-transition-all hover:tw-bg-grey-100" (click)="toggleYearPicker()">{{ currentMonth | date: 'yyyy'
            }}</button>
        </h4>
        <div class="tw-self-stretch tw-justify-start tw-items-center tw-grid tw-grid-cols-7 tw-gap-2 tw-text-center tw-mb-3">
          @for (day of daysOfWeek; track Idx; let Idx = $index) {
          <span class="tw-text-center tw-text-[#828485] tw-text-xs tw-font-normal tw-font-['Satoshi'] tw-leading-[18px]">{{ day }}</span>
          }
        </div>
        <div class="days-grid">
          @for (day of generateDays(currentMonth); track Idx; let Idx = $index) {
          <div class="day-grid-col">
            <button class="day" type="button" [class.inactive]="day.getMonth() !== currentMonth.getMonth()" [class.selected]="isSelected(day)" [class.in-range]="isWithinRange(day)" [class.inactive]="disablePastDates && isPastDate(day)" [disabled]="disablePastDates && isPastDate(day)"

              (click)="selectDate(day)">
              {{ day.getDate() }}
            </button>
          </div>
          }
        </div>
        } @else {
        <h4 class="tw-text-center tw-text-[#010f12] tw-text-lg tw-font-medium tw-font-['Satoshi'] tw-capitalize tw-leading-normal tw-mb-3">
          {{calendarYear}} - {{calendarYear + 11}}
        </h4>
        <div class="year-grid">
          @for (year of generateYearList(calendarYear); track Idx; let Idx = $index) {
          <div class="year-grid-item">
            <button class="year" type="button" (click)="selectYear(year)">{{year}}</button>
          </div>
          }
        </div>
        }
      </div>
      <div class="calendar" *ngIf="!hasSingleCalndar">
        @if (!showYearPicker) {
        <h4 class="tw-text-center tw-text-[#010f12] tw-text-lg tw-font-medium tw-font-['Satoshi'] tw-capitalize tw-leading-normal tw-mb-3">
          <span>{{ nextMonth | date: 'MMMM' }}</span>
          <button type="button" class="tw-px-1 tw-py-0.5 tw-rounded-md tw-ml-1 tw-transition-all hover:tw-bg-grey-100" (click)="toggleYearPicker()">{{ nextMonth | date: 'yyyy'
            }}</button>
        </h4>
        <div class="tw-self-stretch tw-justify-start tw-items-center tw-grid tw-grid-cols-7 tw-gap-2 tw-text-center tw-mb-3">
          @for (day of daysOfWeek; track Idx; let Idx = $index) {
          <span class="tw-text-center tw-text-[#828485] tw-text-xs tw-font-normal tw-font-['Satoshi'] tw-leading-[18px]">{{ day }}</span>
          }
        </div>
        <div class="days-grid">
          @for (day of generateDays(nextMonth); track Idx; let Idx = $index) {
          <div class="day-grid-col">
            <button class="day" type="button" [class.inactive]="day.getMonth() !== nextMonth.getMonth()" [class.selected]="isSelected(day)" [class.in-range]="isWithinRange(day)"
              (click)="selectDate(day)">
              {{ day.getDate() }}
            </button>
          </div>
          }
        </div>
        } @else {
        <h4 class="tw-text-center tw-text-[#010f12] tw-text-lg tw-font-medium tw-font-['Satoshi'] tw-capitalize tw-leading-normal tw-mb-3">
          {{ nextCalStartYear }} - {{ nextCalStartYear+11 }}
        </h4>
        <div class="year-grid">
          @for (year of generateYearList(nextCalStartYear); track Idx; let Idx = $index) {
          <div class="year-grid-item">
            <button class="year" type="button" (click)="selectYear(year)">{{year}}</button>
          </div>
          }
        </div>
        }
      </div>
    </div>
  </div>
  <div class="tw-flex tw-justify-end tw-items-center tw-border-t tw-border-mercury-200 tw-p-3" *ngIf="showApplyButton">
    <div class="tw-text-xs tw-text-grey-400 tw-flex-1" *ngIf="showSelectedDates">
      @if (selectedRange.startDate && selectedRange.endDate && !hasSingleDatePicker) {
      {{ selectedRange.startDate | date: 'MM/dd/yyyy' }} - {{ selectedRange.endDate | date: 'MM/dd/yyyy' }}
      } @else {
      {{ selectedDate | date: 'MM/dd/yyyy' }}
      }
    </div>
    <div class="tw-flex tw-justify-end tw-items-center tw-gap-2">
      <button id="calendar-clear-button" [smlButton]="'link'" [size]="'xs'" type="button" (click)="clearSelectedDates()" *ngIf="showClearButton">Clear</button>
      <button
        id="calendar-apply-button"
        [smlButton]="'primary'"
        [size]="'xs'"
        type="button"
        (click)="applyRange()"
        [disabled]="isApplyDisabled()"
        *ngIf="getTooltipText(); else noTooltip"
        [smlTooltip]="getTooltipText()"
      >
        Apply
      </button>
      <ng-template #noTooltip>
        <button
          id="calendar-apply-button"
          [smlButton]="'primary'"
          [size]="'xs'"
          type="button"
          (click)="applyRange()"
          [disabled]="isApplyDisabled()"
        >
          Apply
        </button>
      </ng-template>
    </div>
  </div>
</div>
